// ============================================================================
// LoadingSpinner Component - Yukleme durumu gostergesi
// ============================================================================
// Farkli boyutlar (sm, md, lg) ve renkler destekler
// Varsayilan olarak ortalanmis
// ============================================================================

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  color?: string
  centered?: boolean
}

export default function LoadingSpinner({ size = 'md', color, centered = true }: LoadingSpinnerProps) {
  // Boyut ayarlari
  const sizeMap = {
    sm: 20,
    md: 40,
    lg: 60,
  }

  const spinnerSize = sizeMap[size]
  const borderWidth = size === 'sm' ? 2 : size === 'md' ? 3 : 4

  // Renk ayari (varsayilan: accent-blue)
  const spinnerColor = color || 'var(--accent-blue)'

  const spinner = (
    <div
      style={{
        width: spinnerSize,
        height: spinnerSize,
        border: `${borderWidth}px solid rgba(255,255,255,.1)`,
        borderTop: `${borderWidth}px solid ${spinnerColor}`,
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }}
      role="status"
      aria-label="Yukleniyor"
    />
  )

  // Ortalanmis wrapper
  if (centered) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          minHeight: 200,
        }}
      >
        {spinner}
      </div>
    )
  }

  return spinner
}
